import Dexie, { type Table } from "dexie"

export interface QueuedFunctionCall {
  id?: number
  action: string
  input: unknown
  createdAt: number
  tempId?: string
  retryCount?: number
  lastError?: string
}

class OfflineDB extends Dexie {
  functionCalls!: Table<QueuedFunctionCall, number>

  constructor() {
    super("shelv-offline")
    // Version 3: Added retryCount and lastError for better queue management
    this.version(3).stores({
      functionCalls: "++id, createdAt, tempId, retryCount",
    })
  }
}

export const offlineDB = new OfflineDB()
